"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOMER_MEMBERSHIP_TYPE = void 0;
exports.CUSTOMER_MEMBERSHIP_TYPE = {
    ANONYMOUS: 'ANONYMOUS',
    FREE: 'FREE',
    TRIAL: 'TRIAL',
    ACTIVE: 'ACTIVE',
    EXPIRING: 'EXPIRING',
    EXPIRED: 'EXPIRED'
};
//# sourceMappingURL=customerMembershipType.js.map